export const UIActionType = {
  TOGGLE_SIDEBAR: 'ui/TOGGLE_SIDEBAR',
  SET_SIDEBAR_OPEN: 'ui/SET_SIDEBAR_OPEN',
  SET_LOADING: 'ui/SET_LOADING',
  RESET_LOADING_KEY: 'ui/RESET_LOADING_KEY',
}

export function createInitialUIState() {
  return {
    sidebarOpen: false,
    /** @type {Record<string, boolean>} */
    loading: {},
  }
}

export function uiReducer(state, action) {
  switch (action.type) {
    case UIActionType.TOGGLE_SIDEBAR:
      return { ...state, sidebarOpen: !state.sidebarOpen }
    case UIActionType.SET_SIDEBAR_OPEN:
      return { ...state, sidebarOpen: action.payload }
    case UIActionType.SET_LOADING: {
      const { key, value } = action.payload
      return {
        ...state,
        loading: { ...state.loading, [key]: value },
      }
    }
    case UIActionType.RESET_LOADING_KEY: {
      const key = action.payload
      const next = { ...state.loading }
      delete next[key]
      return { ...state, loading: next }
    }
    default:
      return state
  }
}
